import axiosInstance from './axiosInstance';

/**
 * Safe-for-client projection of LlmModelOptions on the server. The endpoint
 * never returns the API key or base URL.
 */
export interface AgentModelDto {
  id: string;
  displayName: string;
  isDefault: boolean;
  /**
   * Whether this model can view images.
   *
   * **Required, not optional** — deliberately mirroring the server, where it is a
   * positional record parameter with no default. Making it optional here would
   * let a construction site omit it and publish `undefined`, which reads as
   * "cannot see images" and is indistinguishable from the server actually saying
   * so. The two cases need to stay distinguishable, because the honest answer to
   * "nobody said" is to show the user nothing rather than to warn them.
   *
   * The server enforces the real gate; anything the frontend does with this is a
   * courtesy to the user ahead of that decision.
   */
  supportsVision: boolean;
}

export interface AgentPreferencesDto {
  preferredModelId: string | null;
}

export async function getAgentModels(): Promise<AgentModelDto[]> {
  const response = await axiosInstance.get<AgentModelDto[]>('/api/agent/models');
  return response.data;
}

export async function getAgentPreferences(): Promise<AgentPreferencesDto> {
  const response = await axiosInstance.get<AgentPreferencesDto>('/api/agent/preferences');
  return response.data;
}

export async function setAgentPreferences(
  preferredModelId: string | null
): Promise<AgentPreferencesDto> {
  const response = await axiosInstance.put<AgentPreferencesDto>('/api/agent/preferences', {
    preferredModelId,
  });
  return response.data;
}
